import React, { useState, useEffect } from 'react'
import useTitle from '@/hooks/useTitle'
import { useNavigate } from 'react-router'
import { userProfileIcon2 } from '@/assets/img/imgAssets'
import { PlusIcon, MinusIcon, TrashIcon, PencilSquareIcon,  } from '@heroicons/react/24/outline'
import {
  UserGroupIcon,
  EnvelopeIcon,
  PowerIcon,
  ArrowRightCircleIcon,
} from "@heroicons/react/24/solid"
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import PulseLoader from "react-spinners/PulseLoader"
import { useGetUsersQuery, useGetUserPicQuery } from '../users/usersApiSlice'
import { useGetUserOrgSubscriptionsQuery } from '../userSubscriptions/userOrgSubscriptionsApiSlice'
import { useGetUserTrailSessionPlansQuery } from './userTrailSessionPlansApiSlice'
import { useCreateNewUserTrailSessionExecutionMutation, useGetUserTrailSessionExecutionsQuery } from './userTrailSessionExecutionsApiSlice' // 02 Jun 2024 , 05 Jun 2024 - useGetQuery
import { useGetUserSessionIntroductionsQuery } from './userSessionIntroductionsApiSlice'
import { useGetUserSessionIntrospectionsQuery } from './userSessionIntrospectionsApiSlice' // 13 Jun 2024
import { useGetUserSessionInvestigationsQuery } from './userSessionInvestigationApiSlice' //  02 Jul 2024
import { useGetUserSessionImaginationsQuery } from './userSessionImaginationsApiSlice' // 17 Jul 2024
import { useGetUserSessionImplementationsQuery } from './userSessionImplementationsApiSlice' // 17 Jul 2024
import { useGetUserSessionIlluminationsQuery } from './userSessionIlluminationsApiSlice' // 18 Jul 2024
import { useGetUserSession8848BBDBsQuery } from './userSession8848BBDBsApiSlice' // 27 Jul 2024
import { useGetUserSession8848KYCsQuery } from './userSession8848KYCsApiSlice' // 29 Jul 2024
import { useGetUserSession8848O2DsQuery } from './userSession8848O2DsApiSlice' // 29 Jul 2024
import { useGetUserSession8848NLGsQuery } from './userSession8848NLGsApiSlice' // 29 Jul 2024
import { useGetUserSession8848SSCsQuery } from './userSession8848SSCsApiSlice' // 29 Jul 2024
import EtUserTrailSession8848KYCComp from './EtUserTrailSession8848KYCComp' // 20 Oct 2024

import { useGetUserSessionMissionPlansQuery } from './userSessionMissionPlansApiSlice' // 16 May 2025
import { useGetUserSessionMissionExecutesQuery } from './userSessionMissionExecutesApiSlice' // 16 May 2025

import EtUserTrailBoardCompProd from '../userTrailBoards/EtUserTrailBoardCompProd' // 01 Jul 2026

const EtUserTrailSessionsListProdComp = ({userId,onTotalSessionsUpdate}) => {
    // First Created - 23 Feb 2025
    // Author - Atul Pandey
    // Inherited from EtUserTrailSessionsListComp
    // Updated - 20 Oct 2024 - Added Map of sessionTypeName to components
    // Updated - 16 May 2025 - Added MissionPlan and MissionExecute sessions
    // Updated - 15 Jun 2026 - Added cohort Id based listing
    // Updated - 02 Jul 2026 - Refined for TrailBoard
    
    
    // 0 - Set Page Title
    useTitle('User Trail Sessions List')

    // 1 - set page navigations
    const navigate = useNavigate()

   // 2 - Initialize showDetails state as an object where key is the organization index
   const [showDetails, setShowDetails] = useState(false)
   const [showUserDetails, setShowUserDetails] = useState({}) // 25 May 2024
   const [showTrailSessions, setShowTrailSessions] = useState({}) // 27 May 2024 -- updated 15 Jun 2024 change the state to {} from false
   const [showTrailDetails, setShowTrailDetails] = useState({}) // 27 May 2024

   const [activeTrailTab, setActiveTrailTab] = useState({}) // 02 Jul 2026
  

   // 3 - Extract all the data from the DB
   const {data: usersData, isLoading, isError, error } = useGetUsersQuery()
   const {data: userOrgSubscriptionsData} = useGetUserOrgSubscriptionsQuery()
   const {data: userTrailSessionPlanData} = useGetUserTrailSessionPlansQuery()
   const {data: userTrailSessionExecutionData , isLoading: isExecutionDataLoading } = useGetUserTrailSessionExecutionsQuery() // 05 Jun 2024
   const {data: userSessionIntroductionsData} = useGetUserSessionIntroductionsQuery() // 05 Jun 2024
   const {data: userSessionIntrospectionsData} = useGetUserSessionIntrospectionsQuery() // 13 Jun 2024
   const {data: userSessionInvestigationsData} = useGetUserSessionInvestigationsQuery() // 03 Jul 2024
   const {data: userSessionImaginationsData} = useGetUserSessionImaginationsQuery() // 17 Jul 2024
   const {data: userSessionImplementationsData} = useGetUserSessionImplementationsQuery() // 17 Jul 2024
   const {data: userSessionIlluminationsData} = useGetUserSessionIlluminationsQuery() // 18 Jul 2024
   const {data: userSession8848BBDBsData} = useGetUserSession8848BBDBsQuery() // 27 Jul 2024
   const {data: userSession8848KYCsData} = useGetUserSession8848KYCsQuery() // 29 Jul 2024
   const {data: userSession8848O2DsData} = useGetUserSession8848O2DsQuery() // 29 Jul 2024
   const {data: userSession8848NLGsData} = useGetUserSession8848NLGsQuery() // 29 Jul 2024
   const {data: userSession8848SSCsData} = useGetUserSession8848SSCsQuery() // 29 Jul 2024
   
   const {data: userSessionMissionPlansData} = useGetUserSessionMissionPlansQuery() // 16 May 2025
   const {data: userSessionMissionExecutesData} = useGetUserSessionMissionExecutesQuery() // 16 May 2025
   
   
   const [createNewUserTrailSessionExecution] = useCreateNewUserTrailSessionExecutionMutation() // 02 Jun 2024
   //console.log('users', usersData)
   //console.log('user org subscriptions', userOrgSubscriptionsData)
   //console.log('user trail session plan', userTrailSessionPlanData)
  //  console.log('user trail session execution', userTrailSessionExecutionData)

   // 3a - Build users list from extracted user entities data
   const usersList = usersData?.ids?.map((id) => {
    const user = usersData?.entities[id]
    return user
   })?.filter((user) => user?._id === userId)
  //console.log('users list:', usersList)

  // 3b - Handle toggle show user details -- 23 May 2024 --
  const handleToggleUserDetails = (userId) => {
    setShowUserDetails((prev) => ({ ...prev, [userId]: !prev[userId] }));
  }
  
  // 3c - Handle toggle show user details -- 15 Jun 2024 --
  const handleToggleTrailSessions = (userId) => {
    setShowTrailSessions((prev) => ({ ...prev, [userId]: !prev[userId] }));
  }

  // 3d1 - Handle toggle show trail details -- 15 Jun 2024 --
  const handleToggleTrailDetails = (userId, trailId) => {
    setShowTrailDetails((prev) => ({
        ...prev,
        [userId]: {
            ...prev[userId],
            [trailId]: !prev[userId]?.[trailId],
        },
    }));
  };

  // 3d2 - Handle Trail Tab Change to Show TrailBoard and Trail Sessions as tabs - 02 Jul 2026
  const handleTrailTabChange = (userId, trailId, tabName) => {
    setActiveTrailTab((prev) => ({
      ...prev,
      [userId]: {
        ...prev[userId],
        [trailId]: tabName,
      },
    }))
  }

  // 3e - Load state from localStorage -- 12 Jun 2024
  useEffect(() => {
    const storedShowDetails = localStorage.getItem('showDetails');
    const storedShowUserDetails = localStorage.getItem('showUserDetails');
    const storedShowTrailDetails = localStorage.getItem('showTrailDetails');
    const storedShowTrailSessions = localStorage.getItem('showTrailSessions');

    if (storedShowDetails) {
        setShowDetails(JSON.parse(storedShowDetails));
    }
    if (storedShowUserDetails) {
        setShowUserDetails(JSON.parse(storedShowUserDetails));
    }
    if (storedShowTrailDetails) {
        setShowTrailDetails(JSON.parse(storedShowTrailDetails));
    }
    if (storedShowTrailSessions) {
        setShowTrailSessions(JSON.parse(storedShowTrailSessions));
    }
}, [
  usersData, 
  userOrgSubscriptionsData, 
  userTrailSessionPlanData, 
  userTrailSessionExecutionData, 
  userSessionIntroductionsData, 
  userSessionIntrospectionsData, 
  userSessionInvestigationsData,
  userSessionImaginationsData,  // 17 Jul 2024
  userSessionImplementationsData, // 17 Jul 2024
  userSessionIlluminationsData, // 18 Jul 2024
  userSession8848BBDBsData, // 27 Jul 2024
  userSession8848KYCsData, // 29 Jul 2024
  userSession8848O2DsData, // 29 Jul 2024
  userSession8848NLGsData, // 29 Jul 2024
  userSession8848SSCsData, // 29 Jul 2024
  userSessionMissionPlansData, // 16 May 2025
  userSessionMissionExecutesData, // 16 May 2025
]);

  // 3f Save state to localStorage before page reload -- 12 Jun 2024
  useEffect(() => {
    const handleBeforeUnload = () => {
        localStorage.setItem('showDetails', JSON.stringify(showDetails));
        localStorage.setItem('showUserDetails', JSON.stringify(showUserDetails));
        localStorage.setItem('showTrailDetails', JSON.stringify(showTrailDetails));
        localStorage.setItem('showTrailSessions', JSON.stringify(showTrailSessions));
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [showDetails, showUserDetails, showTrailDetails ,showTrailSessions]);

  // 3g - Function to get trail sessions for a user -- 26 May 2024 -- and group them by trail -- 27 May 2024 -- updated -- 05 Jun 2024 (user execution status)
  const getUserTrailSessionsByTrail = () => {
    if (!userTrailSessionPlanData || !userTrailSessionPlanData?.entities) return { groupedSessions: {}, totalSessions: 0 }

    const userSessions = Object.values(userTrailSessionPlanData?.entities).filter(
      (plan) => plan?.userId?._id.toString() === userId.toString()
    )

    const userSessionExecutions = userTrailSessionExecutionData?.entities ? 
      Object.values(userTrailSessionExecutionData?.entities).filter(
        (execution) => execution.userId._id === userId
      ) : []

    // Group sessions by trailId and count sessions
    const { groupedSessions, totalSessions } = userSessions?.reduce((acc, session) => {
      const trailId = session?.trailId?._id
      if (!acc.groupedSessions[trailId]) {
        acc.groupedSessions[trailId] = {
          trailInfo: session.trailId,
          sessions: [],
          sessionCount: 0, // Initialize session count per trail
        }
      }

      const sessionExecution = userSessionExecutions?.find(
        (execution) => execution.trailId._id === trailId && execution.sessionId._id === session.sessionId._id
      )

      const sessionData = {
        ...session,
        userTrailSessionStatus: sessionExecution ? sessionExecution?.userTrailSessionExecutionStatus : session.userTrailSessionStatus
      }

      acc.groupedSessions[trailId].sessions.push(sessionData)
      acc.groupedSessions[trailId].sessionCount += 1 // Increment session count for the trail
      acc.totalSessions += 1 // Increment total session count

      return acc
    }, { groupedSessions: {}, totalSessions: 0 })

    return { groupedSessions, totalSessions }
  }

 const { groupedSessions, totalSessions } = getUserTrailSessionsByTrail()

 // 3h - Call the callback to update total sessions in the parent
 useEffect(() => {
  if (onTotalSessionsUpdate) {
    onTotalSessionsUpdate(totalSessions) // Update the parent with total sessions
  }
}, [totalSessions, onTotalSessionsUpdate])

  // 4 - Function to create new user trail session execution records -- 02 Jun 2024 -- 15 Jun 2026
  const handleStartSession = async (
    userId, 
    trailId, 
    sessionId, 
    sessionTypeId,
    cohortId,     // 15 Jun 2026
  ) => {

    // 15 Jun 2026
    if (!cohortId) {
      alert("Cohort is missing for this planned session. Please check the user's cohort assignment.")
      return
    }

    try {
        const response = await createNewUserTrailSessionExecution({
            userId,
            trailId,
            sessionId,
            cohortId,   // 15 Jun 2026
        }).unwrap()
        alert(response?.message)
        window.location.reload();
        // Redirect to the session engagement page
        if (sessionTypeId?.sessionTypeName === 'Introduction') {
            navigate(`/userTrailSessions/introduction/${userId}/${trailId}/${sessionId}`)
        }
        // 13 Jun 2024 
        if (sessionTypeId?.sessionTypeName === 'Introspection') {
            navigate(`/userTrailSessions/introspection/${userId}/${trailId}/${sessionId}`)
        }
        // 02 Jul 2024 
        if (sessionTypeId?.sessionTypeName === 'Assessment' ) {
            navigate(`/userTrailSessions/assessment/${userId}/${trailId}/${sessionId}`)
        }
        if (sessionTypeId?.sessionTypeName === 'Investigation' ) {
            navigate(`/userTrailSessions/investigation/${userId}/${trailId}/${sessionId}`)
        }
        // 17 Jul 2024
        if (sessionTypeId?.sessionTypeName === 'Imagination' ) {
          navigate(`/userTrailSessions/imagination/${userId}/${trailId}/${sessionId}`)
        }
        // 17 Jul 2024
        if (sessionTypeId?.sessionTypeName === 'Implementation' ) {
          navigate(`/userTrailSessions/implementation/${userId}/${trailId}/${sessionId}`)
        }
        // 18 Jul 2024
        if (sessionTypeId?.sessionTypeName === 'Illumination' ) {
          navigate(`/userTrailSessions/illumination/${userId}/${trailId}/${sessionId}`)
        }
        // 27 Jul 2024
        if (sessionTypeId?.sessionTypeName === '8848BBDB' ) {
          navigate(`/userTrailSessions/8848bbdb/${userId}/${trailId}/${sessionId}`)
        }

        // 29 Jul 2024
        if (sessionTypeId?.sessionTypeName === '8848KYC' ) {
          navigate(`/userTrailSessions/8848kyc/${userId}/${trailId}/${sessionId}`)
        }

        // 29 Jul 2024
        if (sessionTypeId?.sessionTypeName === '8848O2D' ) {
          navigate(`/userTrailSessions/8848o2d/${userId}/${trailId}/${sessionId}`)
        }

        // 29 Jul 2024
        if (sessionTypeId?.sessionTypeName === '8848NLG' ) {
          navigate(`/userTrailSessions/8848nlg/${userId}/${trailId}/${sessionId}`)
        }

        // 29 Jul 2024
        if (sessionTypeId?.sessionTypeName === '8848SSC' ) {
          navigate(`/userTrailSessions/8848ssc/${userId}/${trailId}/${sessionId}`)
        }

        // 16 May 2025
        if (sessionTypeId?.sessionTypeName === 'MissionPlan' ) {
          navigate(`/userTrailSessions/missionPlan/${userId}/${trailId}/${sessionId}`)
        }

        // 16 May 2025
        if (sessionTypeId?.sessionTypeName === 'MissionExecute' ) {
          navigate(`/userTrailSessions/missionExecute/${userId}/${trailId}/${sessionId}`)
        }

    } catch (error) {
        console.error(error)
        alert('Failed to start the session')
    }
  }

  // 5 - Check if session has been started and get session execution status -- 05 Jun 2024, 15 Jun 2026
  const isSessionStarted = (
    userId, 
    trailId, 
    sessionId,
    cohortId, // 15 Jun 2026
  ) => {

    // 15 Jun 2026 - changes start
    const resolvedCohortId = cohortId?._id || cohortId 

    const userSessionExecution = userTrailSessionExecutionData?.entities ? Object.values(userTrailSessionExecutionData?.entities).find(
      (execution) => {
        const executionCohortId = execution?.cohortId?._id || execution?.cohortId

        return (
          execution.userId._id === userId &&
          execution.trailId._id === trailId &&
          execution.sessionId._id === sessionId &&
          executionCohortId?.toString() === resolvedCohortId?.toString()
        )
      }
    ) : null

    // const userSessionExecution = userTrailSessionExecutionData?.entities ? Object.values(userTrailSessionExecutionData?.entities).find(
    //   (execution) => execution.userId._id === userId && execution.trailId._id === trailId && execution.sessionId._id === sessionId
    // ) : null

    const userSessionIntroduction = userSessionIntroductionsData?.entities ? Object.values(userSessionIntroductionsData?.entities).find(
      (intro) => intro.userId._id === userId && intro.trailId._id === trailId && intro.sessionId._id === sessionId
    ) : null

    // 13 Jun 2024
    const userSessionIntrospection = userSessionIntrospectionsData?.entities ? Object.values(userSessionIntrospectionsData?.entities).find(
      (intro) => intro.userId._id === userId && intro.trailId._id === trailId && intro.sessionId._id === sessionId
    ) : null
    
    // 02 Jul 2024
    const userSessionInvestigation = userSessionInvestigationsData?.entities ? Object.values(userSessionInvestigationsData?.entities).find(
      (intro) => intro.userId._id === userId && intro.trailId._id === trailId && intro.sessionId._id === sessionId
    ) : null
    
    // 17 Jul 2024
    const userSessionImagination = userSessionImaginationsData?.entities ? Object.values(userSessionImaginationsData?.entities).find(
      (intro) => intro.userId._id === userId && intro.trailId._id === trailId && intro.sessionId._id === sessionId
    ) : null

    // 17 Jul 2024
    const userSessionImplementation = userSessionImplementationsData?.entities ? Object.values(userSessionImplementationsData?.entities).find(
      (intro) => intro.userId._id === userId && intro.trailId._id === trailId && intro.sessionId._id === sessionId
    ) : null

    // 18 Jul 2024
    const userSessionIllumination = userSessionIlluminationsData?.entities ? Object.values(userSessionIlluminationsData?.entities).find(
      (intro) => intro.userId._id === userId && intro.trailId._id === trailId && intro.sessionId._id === sessionId
    ) : null

    // 27 Jul 2024
    const userSession8848BBDB = userSession8848BBDBsData?.entities ? Object.values(userSession8848BBDBsData?.entities).find(
      (intro) => intro.userId._id === userId && intro.trailId._id === trailId && intro.sessionId._id === sessionId
    ) : null

    // 29 Jul 2024
    const userSession8848KYC = userSession8848KYCsData?.entities ? Object.values(userSession8848KYCsData?.entities).find(
      (intro) => intro.userId._id === userId && intro.trailId._id === trailId && intro.sessionId._id === sessionId
    ) : null

    // 29 Jul 2024
    const userSession8848O2D = userSession8848O2DsData?.entities ? Object.values(userSession8848O2DsData?.entities).find(
      (intro) => intro.userId._id === userId && intro.trailId._id === trailId && intro.sessionId._id === sessionId
    ) : null

    // 29 Jul 2024
    const userSession8848NLG = userSession8848NLGsData?.entities ? Object.values(userSession8848NLGsData?.entities).find(
      (intro) => intro.userId._id === userId && intro.trailId._id === trailId && intro.sessionId._id === sessionId
    ) : null

    // 29 Jul 2024
    const userSession8848SSC = userSession8848SSCsData?.entities ? Object.values(userSession8848SSCsData?.entities).find(
      (intro) => intro.userId._id === userId && intro.trailId._id === trailId && intro.sessionId._id === sessionId
    ) : null

    // 16 May 2025
    const userSessionMissionPlan = userSessionMissionPlansData?.entities ? Object.values(userSessionMissionPlansData?.entities).find(
      (intro) => intro.userId._id === userId && intro.trailId._id === trailId && intro.sessionId._id === sessionId
    ) : null
    
    // 16 May 2025
    const userSessionMissionExecute = userSessionMissionExecutesData?.entities ? Object.values(userSessionMissionExecutesData?.entities).find(
      (intro) => intro.userId._id === userId && intro.trailId._id === trailId && intro.sessionId._id === sessionId
    ) : null


    return (userSessionExecution && userSessionIntroduction) || (userSessionExecution && userSessionIntrospection) || (userSessionExecution && userSessionInvestigation) || (userSessionExecution && userSessionImagination) || (userSessionExecution && userSessionImplementation) || (userSessionExecution && userSessionIllumination) || (userSessionExecution && userSession8848BBDB) || (userSessionExecution && userSession8848KYC) || (userSessionExecution && userSession8848O2D) || (userSessionExecution && userSession8848NLG) || (userSessionExecution && userSession8848SSC) || (userSessionExecution && userSessionMissionPlan) || (userSessionExecution && userSessionMissionExecute) // 13 Jun 2024 - added || condition, 02 Jul 2024 - added investigation , 17 Jul 2024 - added imagination and implementation, 18 Jul 2024 - added illumination, 27 Jul 2024 - added 8848 BBDB, 29 Jul 2024 - added 8848 KYC, O2D, NLG and SSC, 16 May 2025 - added MisssionPlan and MissionExecute
  }

  // 6 - 02 Jul 2026 - Determine whether this session is still being resolved before displaying Start or Go to Session actions.
  const getSessionAccessState = (
    userId,
    trailId,
    sessionId,
    cohortId
  ) => {
    const resolvedCohortId = cohortId?._id || cohortId

    // Execution query itself has not finished loading yet.
    if (isExecutionDataLoading || !userTrailSessionExecutionData?.entities) {
      return 'loading'
    }

    const matchingExecution = Object.values(
      userTrailSessionExecutionData.entities
    ).find((execution) => {
      const executionCohortId =
        execution?.cohortId?._id || execution?.cohortId

      return (
        execution?.userId?._id?.toString() === userId?.toString() &&
        execution?.trailId?._id?.toString() === trailId?.toString() &&
        execution?.sessionId?._id?.toString() === sessionId?.toString() &&
        executionCohortId?.toString() === resolvedCohortId?.toString()
      )
    })

    // No execution means this session is definitely not started.
    if (!matchingExecution) {
      return 'notStarted'
    }

    // An execution exists. Wait until the typed session check confirms
    // that the session can safely be opened.
    if (
      isSessionStarted(
        userId,
        trailId,
        sessionId,
        resolvedCohortId
      )
    ) {
      return 'started'
    }

    return 'loading'
  }

  if (isLoading || isExecutionDataLoading) return <PulseLoader color={"#ea580c"} />
  if (isError) return <div>Error occurred: {error?.data?.message}</div>

  return (
        <div>
          {usersList?.map((user, userIndex) => (
            <div
              key={user._id + userIndex}
            >                
                <div>
                  <div className="m-1 p-1 rounded bg-gray-200">
                    {Object.entries(groupedSessions)?.length > 0 ? (
                      Object.entries(groupedSessions)?.map(([trailId, { trailInfo, sessions, sessionCount }], trailIndex) => {
                        return (
                          // User Trail Info bar section
                          <div key={trailId + user._id + trailIndex} className="m-1 p-1 bg-white rounded">
                            <div className='grid grid-cols-8 justify-start items-center'>
                              <div className='col-span-2 m-1 p-1 flex justify-start items-center'>
                                <div
                                  className="flex justify-center items-center cursor-pointer rounded-full h-7 w-7 hover:bg-white"
                                  onClick={() => handleToggleTrailDetails(user._id, trailId)}
                                >
                                  {showTrailDetails[user._id]?.[trailId] ? (
                                    <MinusIcon className="h-5 w-5 text-orange-600" />
                                  ) : (
                                    <PlusIcon className="h-5 w-5 text-orange-600" />
                                  )}
                                </div>         
                                <div className='flex justify-start items-center'>
                                  <div className='mx-2 flex justify-center items-center rounded-full bg-gray-50 hover:bg-gray-100 h-8 w-8'>
                                    <img src={trailInfo?.pic} alt="" className='h-6 w-6' />
                                  </div>
                                  <p className="text-sm font-bold">{trailInfo?.trailName}</p>
                                </div>
                              </div>
                              <div className='col-span-1 flex justify-start items-center'>
                                  <div className='rounded-full flex justify-center items-center h-5 w-5 border border-orange-300 bg-gray-50 m-1'><p className='text-orange-600 text-[10px]'>{sessionCount}</p></div>
                              </div>                             
                              
                            </div>


                            {/* 02 Jul 2026 - New Code with Trail Tabs */}

                            {/* Trail Overview / Sessions section */}
                            {showTrailDetails[user._id]?.[trailId] && (
                              <div className="m-1 rounded bg-gray-100 p-1">

                                {/* Trail tabs */}
                                <div className="m-1 flex items-center gap-2 border-b border-gray-200 bg-white px-2 pt-2">
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleTrailTabChange(user._id, trailId, 'overview')
                                    }
                                    className={`rounded-t px-3 py-2 text-xs font-semibold ${
                                      (activeTrailTab[user._id]?.[trailId] || 'overview') ===
                                      'overview'
                                        ? 'border-b-2 border-orange-600 bg-orange-50 text-orange-700'
                                        : 'text-gray-500 hover:bg-gray-100'
                                    }`}
                                  >
                                    Overview
                                  </button>

                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleTrailTabChange(user._id, trailId, 'sessions')
                                    }
                                    className={`rounded-t px-3 py-2 text-xs font-semibold ${
                                      activeTrailTab[user._id]?.[trailId] === 'sessions'
                                        ? 'border-b-2 border-orange-600 bg-orange-50 text-orange-700'
                                        : 'text-gray-500 hover:bg-gray-100'
                                    }`}
                                  >
                                    Sessions
                                  </button>
                                </div>

                                {/* Overview tab */}
                                {(activeTrailTab[user?._id]?.[trailId] || 'overview') ===
                                  'overview' && (
                                  <EtUserTrailBoardCompProd
                                    userId={user?._id}
                                    trailId={trailId}
                                    trailInfo={trailInfo}
                                    sessions={sessions}
                                    userTrailSessionExecutionData={userTrailSessionExecutionData}
                                    onStartSession={handleStartSession}

                                    // 02 Jul 2026 - Existing user-session datasets for consolidated Trail Board tabs
                                    userSessionDataSets={{
                                      introductions: userSessionIntroductionsData,
                                      introspections: userSessionIntrospectionsData,
                                      investigations: userSessionInvestigationsData,
                                      imaginations: userSessionImaginationsData,
                                      implementations: userSessionImplementationsData,
                                      illuminations: userSessionIlluminationsData,
                                      bbdbs: userSession8848BBDBsData,
                                      kycs: userSession8848KYCsData,
                                      o2ds: userSession8848O2DsData,
                                      nlgs: userSession8848NLGsData,
                                      sscs: userSession8848SSCsData,
                                      missionPlans: userSessionMissionPlansData,
                                      missionExecutes: userSessionMissionExecutesData,
                                    }}
                                  />
                                )}

                                {/* Sessions tab */}
                                {activeTrailTab[user?._id]?.[trailId] === 'sessions' &&
                                  sessions?.map((session, sessionIndex) => {

                                    const sessionAccessState = getSessionAccessState(
                                        user?._id,
                                        trailInfo?._id,
                                        session?.sessionId?._id,
                                        session?.cohortId?._id || session?.cohortId
                                      )
                                    
                                    return (
                                      <div
                                        key={session._id + sessionIndex}
                                        className="m-1 rounded bg-white p-1"
                                      >
                                        <div className="m-1 grid grid-cols-10 items-center justify-between p-1">
                                          <div className="col-span-5 flex items-center justify-start">
                                            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-orange-50 hover:bg-orange-100 border border-orange-200">
                                              <img
                                                src={session?.sessionId?.pic}
                                                alt=""
                                                className="h-6 w-6"
                                              />
                                            </div>

                                            <div className="m-1 p-1">
                                              <p className="mx-1 text-sm font-bold">
                                                Session {session?.sessionId?.sessionSequence} -{' '}
                                                {session?.sessionId?.sessionName}
                                              </p>

                                              <p className="m-1 text-[10px]">
                                                {session?.sessionId?.sessionDesc}
                                              </p>
                                            </div>
                                          </div>

                                          <div className="col-span-2 m-1 flex items-center justify-start p-1">
                                            {session?.cohortId && (
                                              <div className="mx-1 flex items-center justify-start px-1">
                                                <p className="mx-1 text-[10px] font-bold">
                                                  Cohort :
                                                </p>

                                                <p className="mx-1 rounded-full bg-orange-100 px-2 py-1 text-[9px] text-orange-700">
                                                  {session?.cohortId?.cohortCode ||
                                                    session?.cohortId?.cohortName ||
                                                    'Cohort'}
                                                </p>
                                              </div>
                                            )}
                                          </div>

                                          <div className="col-span-1 m-1 flex items-center justify-start p-1">
                                            <ExploreOutlinedIcon
                                              sx={{
                                                color: ['Started', 'In Progress', 'Completed'].includes(
                                                  session?.userTrailSessionStatus
                                                )
                                                  ? '#84cc16'
                                                  : '#d4d4d4',
                                              }}
                                            />

                                            <p
                                              className={`mx-1 text-[10px] ${
                                                ['Started', 'In Progress', 'Completed'].includes(
                                                  session?.userTrailSessionStatus
                                                )
                                                  ? 'text-lime-600'
                                                  : 'text-gray-400'
                                              }`}
                                            >
                                              {sessionAccessState === 'loading'
                                                ? 'Loading...'
                                                : session?.userTrailSessionStatus}
                                            </p>
                                          </div>

                                          <div className="col-span-2 m-1 flex items-center justify-between p-1">
                                            {sessionAccessState === 'loading' && (
                                              <div className="flex w-full items-center justify-end px-2">
                                                <PulseLoader
                                                  color="#ea580c"
                                                  size={5}
                                                  margin={2}
                                                />
                                              </div>
                                            )}

                                            {sessionAccessState === 'started' && (
                                              <div
                                                className="flex cursor-pointer items-center justify-end rounded border border-white p-1 shadow"
                                                onClick={() => {
                                                  navigate(
                                                    `/etapp/${session?.sessionId?.sessionTypeId?.sessionTypeName?.toLowerCase()}/${user?._id}/${trailInfo?._id}/${session?.sessionId?._id}`
                                                  )
                                                }}
                                              >
                                                <div>
                                                  <p className="mx-1 px-1 text-[10px] text-gray-400">
                                                    Go to session
                                                  </p>
                                                </div>

                                                <ArrowRightCircleIcon className="h-6 w-6 text-lime-600" />
                                              </div>
                                            )}

                                            {sessionAccessState === 'notStarted' && (
                                              <div
                                                className="flex cursor-pointer items-center justify-end rounded border border-orange-600 p-1 shadow"
                                                onClick={() =>
                                                  handleStartSession(
                                                    user?._id,
                                                    trailInfo?._id,
                                                    session?.sessionId?._id,
                                                    session?.sessionId?.sessionTypeId,
                                                    session?.cohortId?._id || session?.cohortId
                                                  )
                                                }
                                              >
                                                <div>
                                                  <p className="mx-1 px-1 text-[10px] text-gray-400">
                                                    Start the session
                                                  </p>
                                                </div>

                                                <PowerIcon className="h-5 w-5 text-orange-600" />
                                              </div>
                                            )}
                                          </div>

                                          {/* <div className="col-span-1 m-1 flex items-center justify-start p-1">
                                            <ExploreOutlinedIcon
                                              sx={{
                                                color:
                                                  session?.userTrailSessionStatus === 'Started' || "In Progress"
                                                    ? '#84cc16'
                                                    : '#d4d4d4',
                                              }}
                                            />

                                            <p
                                              className={`mx-1 text-[10px] ${
                                                isSessionStarted(
                                                  user?._id,
                                                  trailInfo?._id,
                                                  session?.sessionId?._id,
                                                  session?.cohortId?._id || session?.cohortId
                                                )
                                                  ? 'text-lime-600'
                                                  : 'text-gray-400'
                                              }`}
                                            >
                                              {session?.userTrailSessionStatus}
                                            </p>
                                          </div> */}

                                          {/* <div className="col-span-2 m-1 flex items-center justify-between p-1">
                                            {isSessionStarted(
                                              user?._id,
                                              trailInfo?._id,
                                              session?.sessionId?._id,
                                              session?.cohortId?._id || session?.cohortId
                                            ) ? (
                                              <div
                                                className="flex cursor-pointer items-center justify-end rounded border border-white p-1 shadow"
                                                onClick={() => {
                                                  navigate(
                                                    `/etapp/${session?.sessionId?.sessionTypeId?.sessionTypeName?.toLowerCase()}/${user?._id}/${trailInfo?._id}/${session?.sessionId?._id}`
                                                  )
                                                }}
                                              >
                                                <div>
                                                  <p className="mx-1 px-1 text-[10px] text-gray-400">
                                                    Go to session
                                                  </p>
                                                </div>

                                                <ArrowRightCircleIcon className="h-6 w-6 text-lime-600" />
                                              </div>
                                            ) : (
                                              <div
                                                className="flex cursor-pointer items-center justify-end rounded border border-orange-600 p-1 shadow"
                                                onClick={() =>
                                                  handleStartSession(
                                                    user?._id,
                                                    trailInfo?._id,
                                                    session?.sessionId?._id,
                                                    session?.sessionId?.sessionTypeId,
                                                    session?.cohortId?._id || session?.cohortId
                                                  )
                                                }
                                              >
                                                <div>
                                                  <p className="mx-1 px-1 text-[10px] text-gray-400">
                                                    Start the session
                                                  </p>
                                                </div>

                                                <PowerIcon className="h-5 w-5 text-orange-600" />
                                              </div>
                                            )}
                                          </div> */}
                                        </div>
                                      </div>
                                    )
                                 })}
                              </div>
                            )}

                            {/* 02 Jul 2026 - Prior code - commented */}
                            {/* User Sessions section */}
                            {/* {showTrailDetails[user._id]?.[trailId] && sessions?.map((session, sessionIndex) => {
                              return (
                                <div key={session._id + sessionIndex} className="m-1 p-1 bg-gray-100 rounded">
                                  <div className='m-1 p-1 grid grid-cols-10 justify-between items-center'>
                                    <div className='col-span-5 flex justify-start items-center'>
                                      <div className='flex justify-center items-center rounded-full bg-gray-50 hover:bg-white h-7 w-7'>
                                        <img src={session?.sessionId?.pic} alt="" className='h-5 w-5' />
                                      </div>
                                    
                                      <div className='m-1 p-1'>
                                        <p className='text-sm font-bold mx-1'>Session {session?.sessionId?.sessionSequence} - {session?.sessionId?.sessionName}</p>
                                        <p className='text-[10px] m-1'>{session?.sessionId?.sessionDesc}</p>
                                      </div>
                                    </div>
                                    
                                    <div className='col-span-2 m-1 p-1 flex justify-start items-center'>

                                      {session?.cohortId && (
                                        <div className='flex justify-start items-center mx-1 px-1'>
                                          <p className='font-bold text-[10px] mx-1'>Cohort :</p>
                                          <p className="text-[9px] bg-orange-100 text-orange-700 rounded-full mx-1 px-2 py-1">
                                            {session?.cohortId?.cohortCode ||
                                              session?.cohortId?.cohortName ||
                                              "Cohort"}
                                          </p>
                                        </div>
                                      )}
                                    </div>

                                    <div className='col-span-1 flex m-1 p-1 justify-start items-center'>

                                      <ExploreOutlinedIcon sx={{ color: session?.userTrailSessionStatus === 'Started' ? '#84cc16' : '#d4d4d4' }} />
                                      <p className={`text-[10px] mx-1 ${isSessionStarted(
                                        user?._id, 
                                        trailInfo?._id, 
                                        session?.sessionId._id,
                                        session?.cohortId?._id || session?.cohortId // 15 Jun 2026
                                        ) ? 'text-lime-600' : 'text-gray-400'}`}>
                                        {session?.userTrailSessionStatus}
                                      </p>

                                    </div>

                                    <div className='col-span-2 flex m-1 p-1 justify-between items-center'>
                                      {isSessionStarted(
                                        user?._id, 
                                        trailInfo?._id, 
                                        session?.sessionId._id,
                                        session?.cohortId?._id || session?.cohortId // 15 Jun 2026

                                      ) ? (
                                        <div 
                                          className='flex justify-end items-center border border-white cursor-pointer rounded shadow p-1'
                                          // onClick={() => { navigate(`/userMagicHome/${session?.sessionId?.sessionTypeId?.sessionTypeName.toLowerCase()}/${user?._id}/${trailInfo?._id}/${session?.sessionId._id}`) }}
                                           onClick={() => { navigate(`/etapp/${session?.sessionId?.sessionTypeId?.sessionTypeName.toLowerCase()}/${user?._id}/${trailInfo?._id}/${session?.sessionId._id}`) }} // 23 Feb 2025
                                        >
                                          
                                          <div><p className='text-[10px] mx-1 px-1 text-gray-400'>Go to session</p></div>
                                          <div>
                                            <ArrowRightCircleIcon className='h-6 w-6 text-lime-600'/>
                                          </div>
                                  
                                        </div>
                                      ) : (
                                        <div 
                                          className='flex justify-end items-center border border-orange-600 rounded p-1 shadow cursor-pointer'
                                          onClick={() => handleStartSession(
                                            user?._id, 
                                            trailInfo?._id, 
                                            session?.sessionId?._id, 
                                            session?.sessionId.sessionTypeId,
                                            session?.cohortId?._id || session?.cohortId     // 15 Jun 2026
                                          )}
                                        >
                                          <div><p className='text-[10px] mx-1 px-1 text-gray-400'>Start the session</p></div>
                                          <div>
                                            <PowerIcon className='h-5 w-5 text-orange-600'/>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )
                            })} */}
                          </div>
                        )
                      })
                    ) : (
                      <p className="text-xs">No sessions planned</p>
                    )}
                  </div>

                </div>
            </div>
          ))}
        </div> 
  )
}

const User = ({ username, defaultUserPic }) => {
  const { data: userPic, isFetching: isFetchingUserPic } =
    useGetUserPicQuery(username)

  return (
    <div className="flex justify-center items-center h-12 w-12 rounded-full border border-white bg-gradient-to-r from-orange-600 to-orange-400 shadow-lg shadow-black cursor-pointer">
      {/* Display user picture or loading indicator*/}
      {isFetchingUserPic ? (
        <div>Loading...</div>
      ) : userPic ? (
        <img src={userPic} alt="User" className="h-11 w-11  rounded-full" />
      ) : (
        <img src={defaultUserPic} alt="User" className="h-10 w-10 p-1" />
      )}
    </div>
  )
}

export default EtUserTrailSessionsListProdComp